import { Button } from "@chakra-ui/button";
import { Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay } from "@chakra-ui/modal";
import { useToast } from "@chakra-ui/toast";
import { useState } from "react";
import emailService from "src/access/email";
import FormTitle from "src/form/FormTitle";
import useUserContext from "src/hooks/useUserContext";
import useValidateOnChange from "src/hooks/useValidateOnChange";
import { A } from "src/typography/typography";
import FormInstructions from "./FormInstructions";
import TextInput from "./TextInput";
import Toast from "./Toast";

function TopicRequestModal({ isOpen, onClose }) {
  const { user } = useUserContext()
  const { onChange, isValid } = useValidateOnChange(x => x.length > 2)
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const onSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    const topic = e.target.elements.topic.value

    await emailService.send([{
      to: 'support@projectlink.app',
      template: 'generic-no-button',
      dynamicTemplateData: {
        template: 'generic-no-button',
        subject: 'Topic request',
        body: `Topic request: ${topic} from ${user.displayName}. User id: ${user.uid}`
      },
    }])

    onClose()
    setIsLoading(false)
    toast({
      render: () => <Toast
        description='Topic submitted'
      />
    })
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent as='form' onSubmit={onSubmit}>
        <ModalBody>
          <FormTitle>
            New topic
          </FormTitle>
          <FormInstructions mb='base'>
            Projectlink is in an early beta stage with a limited number of topics.
            Submit your topic and our team will be in touch.
          </FormInstructions>
          <TextInput
            id='topic'
            placeholder='Topic...'
            onChange={onChange}
          />
        </ModalBody>
        <ModalFooter>
          <A onClick={onClose}>
            Cancel
          </A>
          <Button
            variant='success'
            disabled={!isValid}
            isLoading={isLoading}
            type='submit'
            ml='sm'
          >
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default TopicRequestModal
